import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=cb3b6380&scoped=true&"
import script from "./ChatWidget.vue?vue&type=script&lang=ts&"
export * from "./ChatWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=cb3b6380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3b6380",
  null
  
)

export default component.exports